var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstbnLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4989 0.068551V0.137102C9.4989 0.211137 9.44326 0.271462 9.37498 0.271462H0.624658C0.556375 0.271462 0.50074 0.211137 0.50074 0.137102V0.068551C0.50074 0.0301625 0.472921 0 0.437515 0H0.0632249C0.0278189 0 0 0.0301625 0 0.068551V2.1004C0 2.13879 0.0278189 2.16895 0.0632249 2.16895H0.437515C0.472921 2.16895 0.50074 2.13879 0.50074 2.1004V2.03185C0.50074 1.95782 0.556375 1.89749 0.624658 1.89749H9.37498C9.44326 1.89749 9.4989 1.95782 9.4989 2.03185V2.1004C9.4989 2.13879 9.52672 2.16895 9.56213 2.16895H9.93642C9.97182 2.16895 9.99964 2.13879 9.99964 2.1004V0.068551C9.99964 0.0301625 9.97182 0 9.93642 0H9.56213C9.52672 0 9.4989 0.0301625 9.4989 0.068551Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74876 15.7947V15.2407C7.74876 15.2051 7.73612 15.1694 7.71336 15.1448L7.07352 14.4509C7.02547 14.3988 7.00018 14.3302 7.00018 14.2589V1.89844H5.50049V15.7947C5.50049 15.9072 5.58394 15.9977 5.68763 15.9977H7.56414C7.66783 15.9977 7.75129 15.9072 7.75129 15.7947H7.74876Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49681 15.7947V1.89844H2.99712V14.2589C2.99712 14.3302 2.97183 14.3988 2.92378 14.4509L2.28394 15.1448C2.26118 15.1694 2.24854 15.2051 2.24854 15.2407V15.7947C2.24854 15.9072 2.33199 15.9977 2.43568 15.9977H4.31219C4.41588 15.9977 4.49934 15.9072 4.49934 15.7947H4.49681Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstbnLogo);
export default __webpack_public_path__ + "static/media/estbn-logo.34160ab99abcfc7000f22e2f64484f78.svg";
export { ForwardRef as ReactComponent };